import React from 'react';
import './App.css';

function App() {
  const skills = [
    { name: 'Docker', level: 80 },
    { name: 'Jenkins', level: 75 },
    { name: 'Linux', level: 95 },
    { name: 'VSphere', level: 70 },
    { name: 'Proxmox', level: 50 },
    { name: 'PHP', level: 80 },
    { name: 'Javascript', level: 80 },
    { name: 'SQL', level: 90 },
    { name: 'Conception de base de données', level: 90 },
    { name: 'C#', level: 90 }
  ];

  const softSkills = [
    { name: 'Gestion de projet'},
    { name: 'SCRUM'},
    { name: 'Lead d\'une équipe de 3 à 5 personnes'},
    { name: 'Gestion des incidents'},
    { name: 'Capacité d\'écoute'},
    { name: 'Rigueur et organisation'},
    { name: 'Sens de la négociation'},
    { name: 'Aisance relationnelle'},
  ]

  const experience = [
    {
      company: 'SYS1 - ESN, 100 collaborateurs sur Bordeaux et Montpellier',
      position: 'Product Owner / Ingénieur DevOps',
      period: 'Septembre 2023 - Aujourd\'hui, Saint Jean d\'Illac',
      description: [
        'Analyse des besoins et rédaction des fonctionnalités (Métiers et Ségur du Numérique)',
        'Gestion des incidents et demandes',
        'Plannification des ressources et gestion de la roadmap',
        'Animation de cérémonies SCRUM',
        'Elaboration de la méthodologie de tests',
        'Maintien du code du projet/préparation des mises en production',
        'Développement d\'outils pour faciliter les développements/tests',
        'Formation auprès de clients sur de la création d\'indicateurs via METABASE'
      ]
    },
    {
      company: 'SYS1 - ESN, 100 collaborateurs sur Bordeaux et Montpellier',
      position: 'Développeur Web (Alternance)',
      period: 'Septembre 2022 - Septembre 2023, Saint Jean d\'Illac',
      description: [
        'Développement d\'un logiciel médico-social de gestion de dossiers d\'usagers (LOGUS)',
        'Mise en place d\'un environnement d\'Hébergement de Données de Santé (HDS)',
        'Création d\'environnement de production'
      ]
    },
    {
      company: 'GASCOGNE PAPIER - Usine de papier, 350 collaborateurs en France',
      position: 'Développeur WEB',
      period: 'Juillet 2022 - Août 2022, Mimizan',
      description: [
        'Analyse des retours utilisateurs et des nouveaux besoins',
        'Rédaction des fonctionnalités attendues',
        'Rédaction du nouveau cahier des charges technique',
        'Refonte d\'un module de questionnaire vidéo sur tablette pour assurer les accueils sécurité au sein d\'un site d\'industrie lourde'
      ]
    },
    {
      company: 'ISRA VISION - Système de vision par machine, 1300 collaborateurs dans le monde',
      position: 'Software Development Engineer (Stage à l\'étranger)',
      period: 'Septembre 2021 - Janvier 2022, Aix-la-chapelle (Allemagne)',
      description: [
        'Développement de dashboard pour analyse de performances industrielles'
      ]
    },
    {
      company: 'CESI Ecole d\'Ingénieurs',
      position: 'Tuteur assistant à l’enseignement',
      period: 'Septembre 2021 - Janvier 2022, Bordeaux',
      description: [
        'Assistant tuteur chez CESI Bordeaux pour le séminaire d\'intégration des élèves de première année en cycle d\'ingénieur'
      ]
    },
    {
      company: 'GASCOGNE PAPIER - Usine de papier, 350 collaborateurs en France',
      position: 'Développeur WEB (Stage)',
      period: 'Janvier 2021 - Avril 2021, Mimizan',
      description: [
        'Analyse des besoins',
        'Développement d\'un questionnaire vidéo sur tablette pour assurer les accueils sécurité au sein d\'un site d\'industrie lourde'
      ]
    }
  ];

  const projects = [
    {
      title: 'Plateforme de Streaming Personnelle',
      description: 'Développement d\'une plateforme de streaming complète pour usage domestique',
      tech: 'Proxmox, Linux, Docker'
    },
    {
      title: 'Sites de jeux en ligne',
      description: 'Création de multiples sites web pour jouer avec des amis en ligne',
      tech: 'React, NextJS, Vue, JavaScript, PHP, MySQL'
    },
    {
      title: 'Homelab Personnel',
      description: 'Configuration et maintenance d\'un laboratoire domestique pour l\'apprentissage et l\'expérimentation',
      tech: 'Proxmox, Linux, Docker'
    },
    {
      title: 'CV en Ligne',
      description: 'Création d\'un site vitrine pour montrer mes competences et mes projets',
      tech: 'React, Gitlab CI/CD, Jenkins'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800">
      {/* Header */}
      <header className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-cyan-600/20"></div>
        <div className="relative container mx-auto px-6 py-16">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="text-center lg:text-left mb-8 lg:mb-0">
              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-4">
                Xavier <span className="text-blue-400">LABARBE</span>
              </h1>
              <h2 className="text-2xl lg:text-3xl text-blue-300 mb-6">Recherche d'un poste de Product Owner</h2>
              <div className="flex flex-col lg:flex-row gap-4 text-slate-300">
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                  </svg>
                  Bordeaux, France
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                  <a href="mailto:xlabarbe@gmail.com">xlabarbe@gmail.com</a>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="w-64 h-64 rounded-2xl overflow-hidden border-4 border-blue-400/30 shadow-2xl">
                <img
                  src="../unnamed.jpg"
                  alt="Photo de Xavier LABARBE"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
                DevOps/PO
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12">
        {/* About Section */}
        <section className="mb-16">
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-blue-500/20">
            <h3 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
              <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                </svg>
              </div>
              À Propos
            </h3>
            <p className="text-slate-300 text-lg leading-relaxed mb-6">
              Après avoir obtenu mon diplôme d'ingénieur en 2023, j'ai mis à disposition mes connaissances et mon savoir-faire en tant qu'Ingénieur DevOps pour SYS1.
              J'ai aussi pu leur faire profiter de mes compétences en chefferie de projet et les aider à construire les futures fonctionnalités d'un de leurs logiciels.
              Je souhaite désormais m'orienter vers un poste de Product Owner afin de mettre en action mes compétences fraîchement expérimentées à SYS1.
            </p>
            <div className="flex justify-center">
              <a href="/files/CV_Xavier_LABARBE.pdf" target="_blank" type="application/octet-stream" download="CV_Xavier_Labarbe.pdf">
                <button
                    className="group bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white font-semibold py-3 px-6 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl flex items-center gap-3"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                  Télécharger mon CV
                </button>
              </a>
            </div>
          </div>
        </section>

        {/* Skills Section */}
        <section className="mb-16">
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-blue-500/20">
            <h3 className="text-3xl font-bold text-white mb-8 flex items-center gap-3">
              <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              Compétences fonctionnelles
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {softSkills.map((softSkill, index) => {
                return (
                    <div key={index} className="bg-slate-700/50 rounded-xl p-6 border border-blue-500/10">
                      <div className="flex justify-between items-center">
                        <span className="text-white font-semibold">{softSkill.name}</span>
                      </div>
                    </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Skills Section */}
        <section className="mb-16">
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-blue-500/20">
            <h3 className="text-3xl font-bold text-white mb-8 flex items-center gap-3">
              <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              Compétences Techniques
              <div className="relative group ml-2">
                <svg className="w-5 h-5 text-blue-400 cursor-help" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                </svg>
                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-4 py-3 bg-slate-900 text-white text-sm rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-10 w-81">
                  <div className="text-center font-semibold mb-2 text-blue-300">Échelle de compétences :</div>
                  <div className="space-y-1 text-left">
                    <div className="flex items-center gap-2">
                      <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                      <span className="text-yellow-300">&lt; 60% :</span>
                      <span className="text-slate-300">En cours d'apprentissage</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                      <span className="text-orange-300">60-75% :</span>
                      <span className="text-slate-300">Utilisation basique quotidienne</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                      <span className="text-green-300">&gt; 75% :</span>
                      <span className="text-slate-300">Maîtrise professionnelle</span>
                    </div>
                  </div>
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-slate-900"></div>
                </div>
              </div>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {skills.map((skill, index) => {
                let skillLevelClass = '';
                let skillLevelText = '';
                let skillLevelColor = '';

                if (skill.level < 60) {
                  skillLevelClass = 'from-yellow-500 to-yellow-600';
                  skillLevelText = 'En apprentissage';
                  skillLevelColor = 'text-yellow-400';
                } else if (skill.level <= 75) {
                  skillLevelClass = 'from-orange-500 to-orange-600';
                  skillLevelText = 'Utilisation quotidienne';
                  skillLevelColor = 'text-orange-400';
                } else {
                  skillLevelClass = 'from-green-500 to-green-600';
                  skillLevelText = 'Maîtrise professionnelle';
                  skillLevelColor = 'text-green-400';
                }

                return (
                    <div key={index} className="bg-slate-700/50 rounded-xl p-6 border border-blue-500/10">
                      <div className="flex justify-between items-center mb-3">
                        <span className="text-white font-semibold">{skill.name}</span>
                        <span className={`text-sm ${skillLevelColor}`}>{skill.level}%</span>
                      </div>
                      <div className="w-full bg-slate-600 rounded-full h-2 mb-2">
                        <div
                            className={`bg-gradient-to-r ${skillLevelClass} h-2 rounded-full transition-all duration-1000`}
                            style={{ width: `${skill.level}%` }}
                        ></div>
                      </div>
                      <div className={`text-xs ${skillLevelColor} font-medium`}>
                        {skillLevelText}
                      </div>
                    </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Experience Section */}
        <section className="mb-16">
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-blue-500/20">
            <h3 className="text-3xl font-bold text-white mb-8 flex items-center gap-3">
              <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                </svg>
              </div>
              Expérience Professionnelle
            </h3>
            <div className="space-y-8">
              {experience.map((exp, index) => (
                <div key={index} className="relative pl-8 border-l-2 border-blue-500/30">
                  <div className="absolute -left-2 top-0 w-4 h-4 bg-blue-500 rounded-full"></div>
                  <div className="bg-slate-700/30 rounded-xl p-6">
                    <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start mb-4">
                      <div>
                        <h4 className="text-xl font-bold text-white">{exp.position}</h4>
                        <p className="text-blue-400 font-semibold">{exp.company}</p>
                      </div>
                      <span className="text-slate-400 bg-slate-600/50 px-3 py-1 rounded-full text-sm mt-2 lg:mt-0">
                        {exp.period}
                      </span>
                    </div>
                    <ul className="space-y-2">
                      {exp.description.map((desc, i) => (
                        <li key={i} className="text-slate-300 flex items-start gap-2">
                          <span className="text-blue-400">•</span>
                          {desc}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Projects Section */}
        <section className="mb-16">
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-blue-500/20">
            <h3 className="text-3xl font-bold text-white mb-8 flex items-center gap-3">
              <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
                </svg>
              </div>
              Projets Personnels
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {projects.map((project, index) => (
                <div key={index} className="bg-slate-700/30 rounded-xl p-6 border border-blue-500/10 hover:border-blue-500/30 transition-all duration-300">
                  <h4 className="text-xl font-bold text-white mb-3">{project.title}</h4>
                  <p className="text-slate-300 mb-4 leading-relaxed">{project.description}</p>
                  <div className="text-blue-400 text-sm font-semibold bg-blue-500/10 px-3 py-1 rounded-full">
                    {project.tech}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Education Section */}
        <section className="mb-16">
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-blue-500/20">
            <h3 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
              <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
                </svg>
              </div>
              Formation
            </h3>
            <div className="bg-slate-700/30 rounded-xl p-6">
              <h4 className="text-xl font-bold text-white mb-2">Diplôme d'Ingénieur en Informatique</h4>
              <p className="text-blue-400 font-semibold mb-2">Spécialité Développement Logiciel</p>
              <p className="text-slate-400">Obtenu en 2023</p>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-slate-900/80 border-t border-blue-500/20 py-8">
        <div className="container mx-auto px-6 text-center">
          <p className="text-slate-400">
            © 2025 Xavier LABARBE - Ingénieur DevOps
          </p>
          <p className="text-slate-500 mt-2">
            Disponible pour de nouveaux défis !
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;